import { computed, ref } from 'vue';
import { useSelectedIds } from '@/lib/hooks';
import { useQuery } from '@tanstack/vue-query';

import { fetchUsersSimplifiedWithContainerOwnership } from '@/api/user';

import { USERS_SIMPLIFIED_CONTAINERS_API } from '@/constants/api';
import { PATENTS_PLATFORM_FILTERING } from '@/constants/filtering';

import type { UserSimplifiedWithContainerOwnership } from '@/types/users';

function useUsersSimplifiedWithContainerOwnership(
  useParams = false,
  usePatentsPlatformFiltering = true,
  singleUserId?: number
) {
  const selectedIds = useSelectedIds(useParams);
  const parsedSelectedIds = ref(
    selectedIds.value ?? (singleUserId ? [singleUserId] : undefined)
  )

  const { data, isError, isFetching } = useQuery({
    queryKey: [USERS_SIMPLIFIED_CONTAINERS_API, parsedSelectedIds],
    queryFn: () =>
      fetchUsersSimplifiedWithContainerOwnership({
        user_ids: parsedSelectedIds.value,
        ...(usePatentsPlatformFiltering && {
          additionalFilters: PATENTS_PLATFORM_FILTERING
        })
      }),
    select(data) {
      return data.data;
    }
  });

  const simplifiedUsersWithContainerOwnership = computed<UserSimplifiedWithContainerOwnership[]>(() => {
    return data.value ?? []
  });

  return { simplifiedUsersWithContainerOwnership, isError, isFetching };
}

export default useUsersSimplifiedWithContainerOwnership;
